/**
 * SettingsSection -- 공개/비공개, 비밀번호, URL, 만료일 설정
 */

import { useInvitationStore } from '../../../stores/invitationStore.js'
import { DatePicker, Input, Toggle } from '../../ui/index.js'
import styles from './SectionForm.module.css'

export function SettingsSection() {
  const invitation = useInvitationStore((s) => s.invitation)
  const updateNested = useInvitationStore((s) => s.updateNested)
  if (!invitation) return null

  const settings = (invitation as any).settings ?? {}

  return (
    <div className={styles.form}>
      <Toggle
        label="공개"
        checked={settings.isPublic !== false}
        onChange={(v) => updateNested('settings.isPublic', v)}
      />

      <div className={styles.fieldGroup}>
        <Toggle
          label="비밀번호 보호"
          checked={settings.requirePassword === true}
          onChange={(v) => updateNested('settings.requirePassword', v)}
        />
        {settings.requirePassword && (
          <Input
            label="비밀번호"
            type="password"
            value={settings.password ?? ''}
            onChange={(e) => updateNested('settings.password', e.target.value)}
            placeholder="청첩장 열람 비밀번호"
          />
        )}
      </div>

      <DatePicker
        label="만료일"
        value={settings.expiresAt ?? null}
        onChange={(_date, formatted) => updateNested('settings.expiresAt', formatted)}
      />
    </div>
  )
}
